var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',_vm._l((_vm.actionList),function(action){return _c('sui-button',{key:action,attrs:{"content":action},on:{"click":function($event){_vm.buttonAction(action)}}})})),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(_vm.item.modifiedAt,'DD-MM-YYYY')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50c0359b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/classes/ClassTableRow.vue
// module id = null
// module chunks = 